/* eslint-disable import/no-anonymous-default-export */
import Routes from "./Routes";
import NavBoxItems from "./NavBoxItems";
import NavigationItems from "./NavigationItems";
import HeaderNavItems from "./HeaderNavItems";

export default {
  ENV: process.env,

  GoogleIndex: false,

  // Panel Core Config
  Panel: "Agency",
  PanelName: "بهمراه",
  PanelTitle: "شرکت حمل",
  PanelLogo:
    require("@behamrah/behamrah-react-core/dist/assets/images/logo/logotype.svg")
      .default,
  PanelLogoWhite:
    require("@behamrah/behamrah-react-core/dist/assets/images/logo/logotype-white.svg")
      .default,
  PanelLogoMark:
    require("@behamrah/behamrah-react-core/dist/assets/images/logo/logomark.png")
      .default,

  // Routing Config
  Routes,
  HomePageRoute: "/passenger/list",

  // UI Config
  NavBoxItems,
  NavigationItems,
  HeaderNavItems,

  // Auth Page UI Config
  AuthPage: {
    image:
      require("@behamrah/behamrah-react-core/dist/assets/images/auth/agency.svg")
        .default,
    imageStyle: { width: "95%" },
  },
};
